import React from 'react';
import { Button, Modal } from 'antd';
import notice from 'images/new_pop_ups/notice.svg';
import icon_econometrica from 'images/icon_econometrica.svg';

const DelayedDataProcessing = () => {
    return (
        <>
            <Modal
                className="basic-modal-legal-notice"
                title=""
                visible={false}
                // onOk={handleOk}
                // onCancel={handleCancel}
                footer={null}
                closable={false}
                bodyStyle={{ minHeight: 630 }}
                width={400}
            >
                <div className="icon-container">
                    {/* <img
                        className="img-icon-container"
                        src={background_circle_red_modal}
                    />
                    <img
                        className="icon-in-green-circle"
                        src={icon_in_red_circle}
                    /> */}
                    <img
                        src={notice}
                        style={{
                            position: 'absolute',
                            top: '-50px',
                            left: '-50px'
                        }}
                    />
                </div>
                <div>
                    <div style={{ padding: '8px 0 0 0', marginLeft: 6 }}>
                        <p
                            className="header-title"
                            style={{ marginBottom: '30px' }}
                        >
                            Delayed Data Processing
                        </p>
                        <p
                            style={{
                                fontFamily: 'Roboto Regular',
                                fontSize: '16px',
                                lineHeight: '22px'
                            }}
                        >
                            Your data is taking longer than usual to be <br />
                            processed. The larger your file, the longer it{' '}
                            <br />
                            will take to be processed.
                        </p>

                        <p
                            style={{
                                marginTop: 20,
                                fontFamily: 'Roboto Regular',
                                fontSize: '16px',
                                lineHeight: '22px'
                            }}
                        >
                            If you wish to continue using Econometrica <br />
                            while your data is processed, press “OK” to <br />
                            return to the dashboard.
                        </p>

                        <p
                            style={{
                                marginTop: 20,
                                fontFamily: 'Roboto Regular',
                                fontSize: '16px',
                                lineHeight: '22px'
                            }}
                        >
                            Your data will be accesible from there for 24 <br />
                            hours when the operation is complete.
                        </p>
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '179px',
                            paddingBottom: '20px'
                        }}
                    >
                        <img src={icon_econometrica} />
                    </div>
                    <div
                        style={{
                            textAlign: 'center',
                            marginTop: 22,
                            padding: '0 5px',
                            marginBottom: '6px'
                        }}
                    >
                        <button
                            // onClick={handleOk}
                            style={{ height: 29 }}
                            className="ant-btn ant-btn-primary ant-btn-block blue-button"
                        >
                            OK
                        </button>
                        <div
                            // onClick={handleCancel}
                            style={{
                                width: '100%',
                                marginTop: 10,
                                borderColor: '#578cba',
                                color: '#CB2F25',
                                border: '1px solid #CB2F25',
                                height: '28px',
                                display: 'flex',
                                alignItems: 'end',
                                justifyContent: 'center',
                                borderRadius: '3px',
                                fontSize: '14px',
                                fontFamily: 'Roboto Medium',
                                cursor: 'pointer'
                            }}
                        >
                            ABORT DATA PROCESSING
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default DelayedDataProcessing;
